import { default as ThreekitImage } from "../services/ThreekitImage";

const prod = !!(
  window.location.host == "canvasprints.com" ||
  window.location.host == "canvasprintscom.myshopify.com"
);

const cage = prod
  ? {
      height: 640,
      width: 1280,
      objAsset: {
        job_status: "stopped",
        imageassetId: "a61d1161-f2cb-4470-93a4-89c2c6cc7301",
        imagefileId: "661af1d6-f753-4b27-9158-11d8e4681186",
      },
    }
  : {
      height: 640,
      width: 1280,
      objAsset: {
        job_status: "stopped",
        imageassetId: "0b97b001-43d3-43cd-9e5f-d777b37ecd7b",
        imagefileId: "433c2aff-b9f2-4cc4-942e-f5999888736a",
      },
    };

const loading = prod
  ? {
      height: 1200,
      width: 1200,
      objAsset: {
        job_status: "stopped",
        imageassetId: "2490a75d-5601-4452-acff-bdfee2e52196",
        imagefileId: "93400221-d1ea-4666-92c1-ac259490d760",
      },
    }
  : {
      height: 1200,
      width: 1200,
      objAsset: {
        job_status: "stopped",
        imageassetId: "112ea165-e5a6-4575-9d04-d92b00152fe0",
        imagefileId: "a11805cd-82f1-4ef6-87d6-60be8d6429e7",
      },
    };

const fixedImageData = {
  cage,
  loading,
};

const fixedImages = {};
Object.keys(fixedImageData).forEach(
  (name) => (fixedImages[name] = new ThreekitImage(fixedImageData[name]))
);

window.testUpload = () => {
  document.getElementById("reconciler").click();
};

export default fixedImages;
